var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contentBox"},[_c('div',{staticClass:"contentBlock"},[_c('img',{attrs:{"src":_vm.footerImg}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }